import { h, Component } from "preact";
import { route } from "preact-router";
import { Link } from "preact-router/match";
import { Text } from "preact-i18n";
import { localPath } from "../../path";

import DatabasesNav from "../databases-nav";

import style from "./style.css";
import { NL_STRING, EN_STRING } from "../..";

class Header extends Component {
  state = {
    current: NL_STRING,
    [NL_STRING]: "Nederlands",
    [EN_STRING]: "English",
    isLoggedIn: false, // Added isLoggedIn state variable
  };

  componentDidMount = () => {
    if (this.props.locale) {
      this.setState((previousState) => ({
        ...previousState,
        current: this.props.locale,
      }));
    }
    // Check for login status on component mount
    this.checkLoginStatus();
    // Add an event listener for login events
    window.addEventListener("login", this.handleLoginEvent);
  };

  componentWillUnmount() {
    // Remove the event listener when the component unmounts
    window.removeEventListener("login", this.handleLoginEvent);
  }

  handleLoginEvent = () => {
    // Update login status when a login event is received
    this.checkLoginStatus();
  };

  checkLoginStatus = () => {
    // Check if a token exists in sessionStorage (or your preferred storage)
    const token = sessionStorage.getItem("vumc-jwt");
    if (token) {
      this.setState({ isLoggedIn: true });
    } else {
      this.setState({ isLoggedIn: false });
    }
  };

  switchLanguage = () => {
    const currentLocale = this.state.current;
    const newLocale = currentLocale === NL_STRING ? EN_STRING : NL_STRING;

    this.setState((previousState) => {
      return {
        ...previousState,
        current: newLocale,
      };
    });
    this.props.langSwitchClick(newLocale);

    // Get the current path without the locale
    const currentPath = window.location.pathname.replace(/^\/(nl|en)/, "");
    // Route to the new locale with the current path
    route(`/${newLocale}${currentPath}`, true);
    // route(`/${newLocale}`, true);
    // window.location = `/${newLocale}`;
  };

  getLangToSwitchTo = (locale = NL_STRING) => {
    return locale === NL_STRING ? this.state[EN_STRING] : this.state[NL_STRING];
  };

  getSwitchLink(locale = NL_STRING) {
    const newLocale = locale === NL_STRING ? EN_STRING : NL_STRING;
    return `/${newLocale}`;
  }

  handleLogout = () => {
    // Clear login status
    sessionStorage.removeItem("vumc-jwt"); // Remove the token
    this.setState({ isLoggedIn: false });
    // Optionally redirect to login page
    //window.location.href = `/${this.props.locale}/`; // Redirect to home page
    route(`/${this.props.locale}/`, true);
  };

  render({ locale }) {
    return (
      <header class={style.header}>
        <div class={style["nav-wrap"]}>
          <DatabasesNav locale={locale} />
          <nav class={style["nav--main"]} aria-label="Main">
            <Link
              class={style["nav--main__item"]}
              activeClassName={style.active}
              href={localPath(locale, "")}
            >
              Home
            </Link>

            <a
              class={style["nav--main__item"]}
              href={localPath(locale, "admin/roman/literature")}
              native
            >
              Admin
            </a>

            {this.state.isLoggedIn && (
              <a onClick={this.handleLogout} class={style["nav--main__item"]}>
                Logout
              </a>
            )}

            <a
              class={style["nav--main__item"]}
              href={this.getSwitchLink(locale)}
              native
            >
              {this.getLangToSwitchTo(locale)}
            </a>
          </nav>
        </div>
        <h1 class="title--page">
          <Text id="headings.Literatuur en Geneeskunde">
            Literatuur en Geneeskunde
          </Text>
        </h1>
      </header>
    );
  }
}

export default Header;
